'use client'

import { HomeContainer } from '@/components/common/home/home-container'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { useIsMobileClient } from '@/hooks/common/use-device-type'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'

const promotionImages = [
  '/image/2026/12/18/mceclip0_67.jpg',
  '/image/2026/12/18/mceclip1_6.jpg',
  '/image/2026/12/18/mceclip2_84.jpg',
]

export const PromotionCardsSection = () => {
  const isMobile = useIsMobileClient()

  const handleClick = () => {
    //scroll to collection listing
    const listingElement = document.getElementById('collection-listing')
    if (listingElement) {
      listingElement.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <HomeContainer className='my-10 md:my-20'>
      {isMobile ? (
        <Carousel
          opts={{
            align: 'start',
            loop: false,
            containScroll: false,
          }}
          className='w-full'
        >
          <CarouselContent className='-ml-4'>
            {promotionImages.map((imageUrl, index) => (
              <CarouselItem
                key={index}
                className='basis-[85%] pl-4'
                onClick={handleClick}
              >
                <div className='relative overflow-hidden rounded-lg'>
                  <Image
                    src={ImageHelper.getN7ImageUrl(imageUrl)}
                    alt={imageUrl}
                    width={400}
                    height={500}
                    className='h-full w-full object-cover'
                    loading='lazy'
                    sizes='(max-width: 768px) 85vw, 33vw'
                  />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselNavigation />
        </Carousel>
      ) : (
        <div className='grid grid-cols-1 gap-6 md:grid-cols-3'>
          {promotionImages.map((imageUrl, index) => (
            <div
              key={index}
              className='relative cursor-pointer overflow-hidden rounded-lg'
              onClick={handleClick}
            >
              <Image
                src={ImageHelper.getImageUrl(imageUrl)}
                alt=''
                width={400}
                height={500}
                className='h-full w-full object-cover'
                loading='lazy'
                sizes='(max-width: 768px) 100vw, 33vw'
              />
            </div>
          ))}
        </div>
      )}
    </HomeContainer>
  )
}

function CarouselNavigation() {
  return (
    <>
      <CarouselPrevious
        className='absolute -left-3 top-1/2 h-7 w-7 -translate-y-1/2'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute -right-3 top-1/2 h-7 w-7 -translate-y-1/2'
        variant='black'
        hideIfEnd
      />
    </>
  )
}
